import React from 'react';
import StandardAIDetail from './StandardAIDetail';

// Custom template for Claim Synthesis - can be customized later
const ClaimSynthesisDetail = ({ card }) => {
  // For now, use the standard template
  // You can customize this component with specific UI for Claim Synthesis
  return <StandardAIDetail card={card} />;
};

export default ClaimSynthesisDetail;
